<ul *ngIf="steps.length > 0" class="steps has-content-centered">
  <li *ngFor="let step of stepWrappers" class="steps-segment" [class.is-active]="isActive(step)">
    <app-step-segment [step]="step"></app-step-segment>
  </li>
</ul>
